import type { Tenant } from "@moroku/money-webapp-components";

export enum MoneyFeatures {
  InternetBanking = "internet-banking",
  Lending = "lending",
  Onboarding = "onboarding",
  BusinessOnboarding = "business-onboarding",
}

export type MoneyConfig = {
  tenant: Tenant;
  env: MoneyEnvironment;
  isLocal: boolean;
  moneyApi: {
    url: string;
  };
  origin: string;
  amplify: Record<string, any>;
  internalEmailDomain: string;
  enabledFeatures: MoneyFeatures[];
  sentry: {
    environment: MoneyEnvironment;
  };
  passwordless: boolean;
  signUpEnabled: boolean;
  frankie: {
    provider: "smartUi" | "oneSdk" | "oneSdkHosted";
    useEmbedded: boolean;
    url: string;
    onboardingWidgetScriptUrl: string;
  };
  loanApplication: {
    autofillEnabled: boolean;
    creditScore: {
      acceptFiles: string[];
    };
    income: {
      acceptFiles: string[];
    };
    serviceability: {
      acceptFiles: string[];
    };
    idDocs: {
      acceptFiles: string[];
    };
  };
  moneyWebAppUrls?: {
    internetBanking?: string;
    lending?: string;
    onboarding?: string;
  };
  cards?: {
    cardPrimingEnabled?: boolean;
    pinOtp?: {
      enabled: boolean;
      deliveryMode: "sms" | "email";
    };
  };
  onboardingCompleteLink?: string;
};

export enum MoneyEnvironment {
  dev = "dev",
  stg = "stg",
  prd = "prd",
}
